/** 各子系统管理员（fit1 / dist / mfg）— 与能力开通同页（FED-15） */
import { escHtml } from "../lib/hints.js";
import { api, LS } from "../api.js";
import { state } from "../state.js";

function acctCode(text) {
  return text ? `<code class="mcp-acct-code">${escHtml(text)}</code>` : "—";
}

/**
 * @param {HTMLElement | null} adminsBox
 * @param {{ onChanged?: () => void }} [opts]
 */
export function renderSystemAdminsSection(adminsBox, opts = {}) {
  if (!adminsBox) return;
  const SYS_LABEL = { fit1: "平台 fit1", dist: "分销 dist", mfg: "生产 mfg" };
  adminsBox.innerHTML = '<span class="mcp-acct-empty">加载中…</span>';
  void (async () => {
    const me = state.me || {};
    const { ok, data } = await api("GET", "/api/v1/merchant/system-admins");
    if (!ok || !data) {
      adminsBox.innerHTML =
        '<span class="mcp-acct-empty">加载失败（需商家管理员权限）</span>';
      return;
    }
    const by = data.by_system || {};
    const systems = data.systems || ["fit1", "dist", "mfg"];
    const myPid = me.console_person_id || localStorage.getItem(LS.personId) || "";
    let html = "";
    let any = false;
    systems.forEach((sys) => {
      const items = by[sys] || [];
      any = any || items.length > 0;
      html += `<div class="mcp-acct-row" style="margin-top:8px"><div class="mcp-acct-label">${escHtml(SYS_LABEL[sys] || sys)}（${items.length}）</div></div>`;
      if (!items.length) {
        html += '<span class="mcp-acct-empty">暂无管理员许可行</span>';
        return;
      }
      html += items
        .map((g) => {
          const pid = escHtml(g.person_id || "");
          const party = escHtml(g.party_id || "");
          const self = myPid && g.person_id === myPid;
          const demote = self
            ? '<button type="button" class="secondary" disabled title="不能处置自己">降级</button>'
            : `<button type="button" class="secondary js-demote-admin" data-sys="${escHtml(sys)}" data-pid="${pid}" data-party="${party}">降级</button>`;
          const disable = self
            ? '<button type="button" class="secondary" disabled title="不能处置自己">禁用</button>'
            : `<button type="button" class="secondary js-disable-admin" data-sys="${escHtml(sys)}" data-pid="${pid}" data-party="${party}">禁用</button>`;
          return (
            `<div class="mcp-acct-row" style="align-items:center">` +
            `<div class="mcp-acct-val" style="flex:1">${acctCode(g.person_id)} · ${escHtml(g.role_code || "admin")}</div>` +
            demote +
            disable +
            `</div>`
          );
        })
        .join("");
    });
    if (!any) {
      html =
        '<span class="mcp-acct-empty">暂无 fit1 / dist / mfg 管理员许可行（存量店可能仅走成员/OAuth）</span>' +
        html;
    }
    adminsBox.innerHTML = html;
    const act = async (kind, btn) => {
      const sys = btn.getAttribute("data-sys") || "";
      const label =
        kind === "demote"
          ? "降级（去管理员，仍可登录该系统）"
          : "禁用（停用该系统许可）";
      if (
        !confirm(
          `确认对该用户执行「${label}」？\n系统：${sys}\nperson_id：${btn.getAttribute("data-pid")}`
        )
      )
        return;
      const body = {
        person_id: btn.getAttribute("data-pid"),
        party_id: btn.getAttribute("data-party") || "",
        system: sys,
      };
      const path =
        kind === "demote"
          ? "/api/v1/merchant/system-admins/demote"
          : "/api/v1/merchant/system-admins/disable";
      const res = await api("POST", path, body);
      if (!res.ok) {
        alert((res.data && (res.data.detail || res.data.message)) || "操作失败");
        return;
      }
      if (opts.onChanged) opts.onChanged();
      else renderSystemAdminsSection(adminsBox, opts);
    };
    adminsBox.querySelectorAll(".js-demote-admin").forEach((btn) => {
      btn.addEventListener("click", () => act("demote", btn));
    });
    adminsBox.querySelectorAll(".js-disable-admin").forEach((btn) => {
      btn.addEventListener("click", () => act("disable", btn));
    });
  })();
}
